export default __webpack_public_path__ + "static/media/tier-5-img.782e409a.svg";